import {Component} from '@angular/core';
import {LoginService} from '../shared/auth/login/login.service';
import {Principal} from '../shared/auth/principal.service';

@Component({
  selector: 'cm-demand-partner-main',
  templateUrl: './demand-partner-main.component.html',
  styleUrls: ['./demand-partner-main.component.scss']
})
export class DemandPartnerMainComponent {

  isAllowedToSeeBlocklists = false;
  mobileMenu;

  constructor(private loginService: LoginService,
              public principal: Principal) {
    this.isAllowedToSeeBlocklists = ['AOL', 'Sonobi', 'Index', 'Sovrn', 'PulsePoint'].includes(principal.demandPartner.name);
  }

  public logout() {
    this.loginService.logout(true);
  }

}
